import { css } from "@emotion/react";

import { useWhiteLabel } from "contexts/WhiteLabelContext";

import { lightenColor } from "utils/colors";
import { down } from "utils/mediaQueryStrings";

import { gradient } from "constants/colors";

const style = {
  background: css({
    height: "100vh",
    width: "100vw",
    [down("mobile")]: {
      display: "block",
    },
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    position: "fixed",
    justifyContent: "center",
    overflow: "auto",
    overflowX: "hidden",
  }),
  card: css({
    margin: "auto",
    [down("mobile")]: {
      height: "-webkit-fill-available",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
  }),
};

type Props = {
  children: React.ReactNode;
};

export const OnboardingContainer = ({ children }: Props) => {
  // this component can be used outside of the white label context
  const whiteLabel = useWhiteLabel(false);
  const backgroundColor = whiteLabel?.interviewStyle?.backgroundColor;
  return (
    <div
      css={[
        style.background,
        css({
          background: backgroundColor
            ? lightenColor(backgroundColor)
            : gradient.background,
        }),
      ]}
    >
      <div css={[style.card]}>{children}</div>
    </div>
  );
};
